import { RefObject } from "react";
import { Button, Anchor } from "@newsela/angelou";
import PanelHeader from "@/view/PanelHeader";
import {
  GenerationGeniusAPIResponse,
  IGeniusPDF,
} from "@/types/models/GenerationGenius.interface";
import { formatGeniusActivityPanelContent } from "../GeniusContent/utils";
import {
  IGeniusButtonEventProperties,
  RESOURCE_NAMES,
} from "../GeniusContent/GeniusActivityPanel/GeniusActivityPanel.constant";
import {
  instructionsCss,
  resourceBtnCss,
  titleCss,
  drawerContainerCss,
  subheadingCss,
} from "./GeniusTeacherResourcesContainer.style";

interface GeniusTeacherResourcesProps {
  backButtonEventProperties: IGeniusButtonEventProperties;
  closeButtonEventProperties: IGeniusButtonEventProperties;
  onClickBackButton: () => void;
  onClickCloseButton?: () => void;
  shouldFocusCloseButtonRef: RefObject<boolean>;
  contentData: GenerationGeniusAPIResponse;
}

export const GeniusTeacherResourcesContainer = ({
  backButtonEventProperties,
  closeButtonEventProperties,
  onClickBackButton,
  onClickCloseButton,
  shouldFocusCloseButtonRef,
  contentData,
}: GeniusTeacherResourcesProps) => {
  const { pdfResources = [] } = formatGeniusActivityPanelContent(contentData);

  const teacherGuide = pdfResources.find(
    (resource: IGeniusPDF) => resource.type === "teacher_guide",
  );

  const lessonPlan = pdfResources.find(
    (resource: IGeniusPDF) => resource.type === "lesson_plan",
  );
  return (
    <>
      <PanelHeader
        onClickBackButton={onClickBackButton}
        onClickCloseButton={onClickCloseButton}
        backButtonEventProperties={backButtonEventProperties}
        closeButtonEventProperties={closeButtonEventProperties}
        shouldFocusCloseButtonRef={shouldFocusCloseButtonRef}
      >
        <h2 css={titleCss}>Teacher Resources</h2>
      </PanelHeader>

      <div css={drawerContainerCss}>
        <h3 css={subheadingCss}>Download Teacher Resources</h3>
        <p css={instructionsCss}>
          Download the full lesson plan to save time and feel confident leading
          an engaging, standards-aligned lesson. You can also download the
          Teacher Information PDF for helpful context, including background
          information, tips, and misconceptions.
        </p>
        {[lessonPlan, teacherGuide].map((resource) => {
          return resource ? (
            <Anchor
              __cssFor={resourceBtnCss}
              styleAnchorAsButton={{
                flavor: Button.flavors.muted,
                isFullWidth: true,
              }}
              href={resource?.url}
              openInNewTab
            >
              {RESOURCE_NAMES[resource?.type] ?? "Resource"} (PDF)
            </Anchor>
          ) : null;
        })}
      </div>
    </>
  );
};

export default GeniusTeacherResourcesContainer;
